import React, { useMemo, useState } from "react";
import { StreamProvider } from "@teamrota/shiftstreamlib";

import ShiftStream from "../..";
import { useAccounts } from "../../graphql/use-accounts";
import Table from "./Table";
import { FilterSelect } from "../styles";
import { getFilterableProviders, getProviderLabel } from "../../utils";

export const COL_WIDTHS = [
  "6vw",
  "19vw",
  "8vw",
  "11vw",
  "11vw",
  "11vw",
  "11vw",
  "8vw",
];

export const Home = () => {
  const { accounts, loading } = useAccounts();
  const [providerFilter, setProviderFilter] = useState<"all" | StreamProvider>(
    "all",
  );
  const providerOptions = getFilterableProviders() as StreamProvider[];

  const filteredAccounts = useMemo(() => {
    if (providerFilter === "all") {
      return accounts;
    }

    return accounts.filter(
      (account: any) => account.provider === providerFilter,
    );
  }, [accounts, providerFilter]);

  return (
    <ShiftStream>
      <div style={{ width: "87vw", marginBottom: 16 }}>
        <FilterSelect
          id="stream-provider-filter"
          value={providerFilter}
          onChange={(e) =>
            setProviderFilter(
              e.target.value === "all"
                ? "all"
                : (e.target.value as StreamProvider),
            )
          }
        >
          <option value="all">All Providers</option>
          {providerOptions.map((provider) => (
            <option key={provider} value={provider}>
              {getProviderLabel(provider)}
            </option>
          ))}
        </FilterSelect>
      </div>

      <Table accounts={filteredAccounts} loading={loading} />
    </ShiftStream>
  );
};

export default Home;
